import { Typography } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import { COLORS } from "../../theme";

const defaultProps = {
  fontWeight: 600,
  color: '#2C2C2C', // Svart enligt styleguide
  fontFamily: 'Poppins, sans-serif',
  sx: {}
};

export const H2 = ({ children, fontWeight, color, fontFamily, sx }) => {
  return (
    <Typography 
      variant="h2" 
      sx={{ 
        fontWeight: fontWeight || 600, 
        color: color || '#2C2C2C', 
        fontFamily: fontFamily || 'Poppins, sans-serif', 
        marginBottom: '1rem', // 16px default spacing
        ...(sx || {}) 
      }}
    >
      {children}
    </Typography>
  );
};

H2.propTypes = {
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  fontFamily: PropTypes.string,
  sx: PropTypes.object
};

H2.defaultProps = defaultProps;

export default H2;
